import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectSuppressSecondaryContent } from 'containers/App/selectors';

// Unmount component if secondary content is being suppressed.
// Place as high in the HOC order as possible to prevent the component's other
//   HOCs from unnecessarily running while it is being suppressed.

const withSuppressedMount = BaseComponent => {
  return props =>
    !props.suppressSecondaryContent && <BaseComponent {...props} />;
};

const mapStateToProps = createStructuredSelector({
  suppressSecondaryContent: makeSelectSuppressSecondaryContent()
});

const withConnect = connect(mapStateToProps, null);

const withSuppressAsSecondaryContent = BaseComponent =>
  withConnect(withSuppressedMount(BaseComponent));

export default withSuppressAsSecondaryContent;
